import React from 'react';
import { pickDomAttrs } from '../../_util/utils';
import Space from '../../space';
import Tooltip from '../../tooltip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MoreInTooltip(_ref) {
  let {
    items,
    itemRender,
    emptyHolder = '-',
    className,
    style,
    ...restProps
  } = _ref;
  const attrs = pickDomAttrs(restProps);
  if (!(items !== null && items !== void 0 && items.length)) {
    return /*#__PURE__*/_jsx("span", {
      ...attrs.data,
      children: emptyHolder
    });
  }
  const [firstItem, ...otherItems] = items;
  return /*#__PURE__*/_jsxs(Space, {
    ...attrs.data,
    block: true,
    size: 4,
    className: className,
    style: style,
    children: [/*#__PURE__*/_jsx("div", {
      children: itemRender(firstItem, 0)
    }), otherItems.length > 0 && /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(Space, {
        direction: "vertical",
        style: {
          maxHeight: 200,
          overflowY: 'auto',
          padding: '4px 0'
        },
        children: otherItems.map((item, idx) => /*#__PURE__*/_jsx("div", {
          children: itemRender(item, idx + 1)
        }, idx))
      }),
      children: /*#__PURE__*/_jsxs("a", {
        children: ["+", otherItems.length]
      })
    })]
  });
}